/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/**
 * author: LK & Rex
 */

import { cloneQuestion, regenSubQuestionId, getCountryIdByQuestionIdAndIndicator, getIndustryLevelIdByQuestionIdAndIndicator, getResOrBusOpeSitCodeLevelIdByQuestionIdAndIndicator } from './AOFormUtils.js';
import { isArrayFn, isStrFn, isObjFn } from './ValidationUtils';
//import { cloneQuestion,regenSubQuestionId} from './AOFormUtils.js';

/*
  1-Radio button, 2-Check box, 5-Drop down list
 */
const chosenAnswerTypes = [1, 2, 5, 10];
/*
  4-Input, 7-Mobile number, 8-Telephone number, 16-Date input, 21-Input digit, 23-Input percentage, 24-Text area
 */
const contentAnswerTypes = [4, 7, 8, 9, 16, 21, 23, 24];


export const installAOFormJsonTree2 = (application, answers, countryList, industryLevelList, resOrBusOpeSitCodeLevelDatasRoots) => {

  let sections = application.sections;
  let ansDetails = answers.answerDetails;
  let questionStatus = answers.questionStatus;
  let allIndicatorMap = {};

  if (isArrayFn(sections) && !!ansDetails) {

    // convert application to a map of indicators
    for (let i = 0; i < sections.length; i++) {
      let formObj = sections[i];
      let questions = formObj.questions;
      for (let i = 0; i < questions.length; i++) {
        mapQuestions(questions[i], allIndicatorMap)
      }
    }
    // handle question answers
    for (let key in ansDetails) {
      let question = allIndicatorMap[key];
      let ans = ansDetails[key];
      if (!!question) {
        if (isArrayFn(ans)) {
          // handle array type answers
          let parentQuestion = allIndicatorMap[key + "Group"];
          if (!!parentQuestion) {
            for (let i = 1; i < ans.length; i++) {
              let newSubQuestion = cloneQuestion(question);
              parentQuestion.subQuestions.push(newSubQuestion)
            }
            regenSubQuestionId(parentQuestion);
            for (let i = 0; i < ans.length; i++) {
              let itemAns = ans[i];
              let itemSubQuestion = parentQuestion.subQuestions[i];
              handleSubLevelsQuestion2(itemSubQuestion, itemAns, countryList, industryLevelList, resOrBusOpeSitCodeLevelDatasRoots)
            }
          } else {
            // console.log("can't found question by indicator["+key+"Group]");
          }
        } else {
          // handle string type answers
          setUpUserAnswer2(question, ans, countryList, industryLevelList, resOrBusOpeSitCodeLevelDatasRoots)
        }
      } else {
        // console.log("can't found question by indicator["+key+"]");
      }
    }
    // handle question status
    for (let key in questionStatus) {
      let status = questionStatus[key];
      if (status.length > 1) {
        // panel has more than one subQuestion, need to locate its parent question and setup each panel's status
        let question = allIndicatorMap[key + "Group"];
        const subQuestionStatus = status.split(',');
        setupPanelStatus(question, subQuestionStatus)
      } else {
        // section or panel has one subQuestion, set its question status
        if (allIndicatorMap[key]) {
          allIndicatorMap[key].questionStatus = parseInt(status, 10)
        }
      }
    }

  }

};

export const mapQuestions = (question, allIndicatorMap) => {
  if (!!question.questionIndicator) {
    if (!!allIndicatorMap[question.questionIndicator]) {
      // console.log("duplicate questionIndicator by question [" + question.questionId + "]")
    } else {
      allIndicatorMap[question.questionIndicator] = question
    }
    if (!!question.subQuestions) {
      for (let i = 0; i < question.subQuestions.length; i++) {
        mapQuestions(question.subQuestions[i], allIndicatorMap)
      }
    }
  } else {
    // console.log("can't found questionIndicator by question [" + question.questionId + "]")
  }

};

export const setupPanelStatus = (question, statusArray) => {
  if (!!question.subQuestions) {
    for (let i = 0; i < question.subQuestions.length; i++) {
      const panelStatus = statusArray.shift();
      question.subQuestions[i].questionStatus = !!panelStatus ? parseInt(panelStatus, 10) : 0
    }
  }
};

export const handleSubLevelsQuestion2 = (question, ans, countryList, industryLevelList, resOrBusOpeSitCodeLevelDatasRoots) => {
  if (isStrFn(ans)) {
    //question.userAnswer=ans
    setUpUserAnswer2(question, ans, countryList, industryLevelList, resOrBusOpeSitCodeLevelDatasRoots)
  }
  if (isArrayFn(ans) && !!question.subQuestions) {
    let subQuestion = question.subQuestions[0];
    // add subQuestions base on its answers count
    for (let i = 1; i < ans.length; i++) {
      let newSubQuestion = cloneQuestion(subQuestion);
      question.subQuestions.push(newSubQuestion)
    }
    regenSubQuestionId(question);
    for (let i = 0; i < ans.length; i++) {
      let itemAns = ans[i];
      let itemSubQuestion = question.subQuestions[i];
      handleSubLevelsQuestion2(itemSubQuestion, itemAns, countryList, industryLevelList, resOrBusOpeSitCodeLevelDatasRoots)
    }
  }
  if (!isArrayFn(ans) && isObjFn(ans) && !!question.subQuestions) {

    //add logic for set value to parent question and it's children
    if (!!ans && !!ans.value && isStrFn(ans.value)) {
      setUpUserAnswer2(question, ans.value, countryList, industryLevelList, resOrBusOpeSitCodeLevelDatasRoots)
    }
    ///////////

    let indicatorMap = {};

    for (let i = 0; i < question.subQuestions.length; i++) {
      let item = question.subQuestions[i];
      if (!!item.questionIndicator && item.questionIndicator !== '') {
        //eval("indicatorMap."+item.questionIndicator+"=item");
        indicatorMap[item.questionIndicator] = item
      }
    }
    for (let key in ans) {
      let trueKey = key;
      let itemAns = ans[key];
      if (isArrayFn(itemAns)) {
        trueKey = key + "Group"
      }
      if (trueKey !== 'value') {
        //handleSubLevelsQuestion2(indicatorMap[trueKey],itemAns,countryList)
        if (!!indicatorMap[trueKey]) {
          handleSubLevelsQuestion2(indicatorMap[trueKey], itemAns, countryList, industryLevelList, resOrBusOpeSitCodeLevelDatasRoots)
        } else {
          // handle phone type's each subQuestion's value
          // let foundQuestionWithinSubQuestion = false;
          for (let sqKey in indicatorMap) {
            if (!!indicatorMap[sqKey].subQuestions) {
              const _SUB_QUESTIONS = indicatorMap[sqKey].subQuestions;
              for (let i = 0; i < _SUB_QUESTIONS.length; i++) {
                if (_SUB_QUESTIONS[i].questionIndicator === trueKey) {
                  handleSubLevelsQuestion2(_SUB_QUESTIONS[i], itemAns, countryList, industryLevelList, resOrBusOpeSitCodeLevelDatasRoots);
                  // foundQuestionWithinSubQuestion = true
                }
              }
            }
          }
          // !foundQuestionWithinSubQuestion && console.log("can't found question by indicator["+trueKey+"]")
        }
      }
    }
  }
};

export const setUpUserAnswer2 = (question, ans, countryList, industryLevelList, resOrBusOpeSitCodeLevelDatasRoots) => {
  let answerType = question.answerType;
  if (chosenAnswerTypes.indexOf(answerType) !== -1) {
    let questionAnswers = question.answers;
    if (answerType === 2 && ans.indexOf(",") !== -1) {
      // checkbox with multiple answers
      let indicatorMap = {};
      let selectIndicators = ans.split(",");
      let resIds = "";
      for (let i = 0; i < questionAnswers.length; i++) {
        let itemAns = questionAnswers[i];
        indicatorMap[itemAns.answerIndicator] = itemAns.answerId
      }
      for (let i = 0; i < selectIndicators.length; i++) {
        let toId = indicatorMap[selectIndicators[i]];
        if (!!toId) {
          resIds = resIds + "," + toId
        }
      }
      resIds = resIds.substring(1);
      question.userAnswer = {
        chosenAnswerId: resIds
      }
    } else {
      for (let i = 0; i < questionAnswers.length; i++) {
        let itemAns = questionAnswers[i];
        if (itemAns.answerIndicator === ans) {
          question.userAnswer = {
            chosenAnswerId: itemAns.answerId
          };
          break;
        }
      }
    }

  } else if (contentAnswerTypes.indexOf(answerType) !== -1) {
    question.userAnswer = {
      contents: [ans]
    }
  } else if (answerType === 27) {
    let genChosenAnswerId = getCountryIdByQuestionIdAndIndicator(question.questionId, ans, countryList);
    if (ans) {
      question.userAnswer = {
        chosenAnswerId: genChosenAnswerId
      }
    }
  } else if (answerType === 11) {
    let answerId = getIndustryLevelIdByQuestionIdAndIndicator(question, ans, industryLevelList);
    question.userAnswer = {
      chosenAnswerId: answerId
    }
  } else if (answerType === 110) { //RBBOB-15726 AC2
    let answerId = getResOrBusOpeSitCodeLevelIdByQuestionIdAndIndicator(question, ans, resOrBusOpeSitCodeLevelDatasRoots);
    question.userAnswer = {
      chosenAnswerId: answerId
    }
  } else {
    //nothing to do
  }
};



// WEBPACK FOOTER //
// ./src/utils/AOFormJsonHandler2.js